/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const router = require('../router.js');
const tip = require('components/base/pop/tip');


/**
 * @param {String} url
 * @param {Object} opts
 *       {String} type - 'get' | 'post'
 *       {String} dataType - default is json
 *       {String} contentType:
 *
 */
const ajaxHttp = function (url, opts = {}) {
  let ajaxOptions = {
    url: url,
    type: 'GET',
    dataType: 'json',
  }

  let token = window.localStorage.getItem('appBackToken');
  if (token) {
    ajaxOptions.headers = { token: token };
  }

  Object.assign(ajaxOptions, opts);

  return new Promise((resolve, reject) => {
    $.ajax(Object.assign(ajaxOptions, {
      success: (res) => {
        if (res.code === 0) {
          resolve(res);
        } else if(res.code === 4012) {
          tip('登录信息过期');
          window.localStorage.removeItem('appBackToken');
          AB.TOKEN = null;

           let _hash = window.location.hash,
            _idx =_hash.indexOf("/");
            _hash = _hash.substring(_idx);
            if(_hash!="/login" && _hash.indexOf('/page') !=-1){
              sessionStorage.setItem("cbkURL",_hash);
            }


          setTimeout(()=>{
            router.go({
              path: '/login'
            });
          }, 500);
        } else {
          reject(res);
        }
      },
      error: (err) => {
        tip('网络异常，请检查网络连接或重试');
      }
    }))
  })
}

module.exports = ajaxHttp;



// WEBPACK FOOTER //
// ./src/appBackend/utils/ajaxHttp.js